{
    "Accessibility Menu": "منوی دسترسی",
    "Reset settings": "بازنشانی تنظیمات",
    "Close": "بستن",
    "Content Adjustments": "تنظیمات محتوا",
    "Adjust Font Size": "تنظیم اندازه فونت",
    "Highlight Title": "برجسته کردن عنوان",
    "Highlight Links": "برجسته کردن لینک‌ها",
    "Readable Font": "فونت خوانا",
    "Color Adjustments": "تنظیمات رنگ",
    "Dark Contrast": "کنتراست تاریک",
    "Light Contrast": "کنتراست روشن",
    "High Contrast": "کنتراست بالا",
    "High Saturation": "اشباع بالا",
    "Low Saturation": "اشباع پایین",
    "Monochrome": "تک‌رنگ",
    "Protanopia": "پروتانوپیا",
    "Deuteranopia": "دوترانوپیا",
    "Tritanopia": "تریتانوپیا",
    "Visual & Navigation Aids": "کمک‌های بصری و ناوبری",
    "Additional Tools": "ابزارهای اضافی",
    "Reading Guide": "راهنمای خواندن",
    "Stop Animations": "توقف انیمیشن‌ها",
    "Big Cursor": "مؤشر بزرگ",
    "Screen Reader": "صفحه‌خوان",
    "Hide Images": "پنهان کردن تصاویر",
    "Image Tooltips": "راهنمای تصاویر",
    "Page Structure": "ساختار صفحه",
    "Super Focus": "تمرکز فوق‌العاده",
    "Magnifier": "ذره‌بین",
    "Increase Font Size": "افزایش اندازه فونت",
    "Decrease Font Size": "کاهش اندازه فونت",
    "Letter Spacing": "فاصله بین حروف",
    "Line Height": "ارتفاع خط",
    "Font Weight": "وزن فونت",
    "Dyslexia Font": "فونت دیسلکسیا",
    "Language": "زبان",
    "Open Accessibility Menu": "بازکردن منوی دسترسی",
    "Accessibility Profiles": "پروفایل‌های دسترسی",
    "Seizure Safe Profile": "پروفایل ایمن برای صرع",
    "Stops animations and reduces color saturation.": "انیمیشن‌ها را متوقف و اشباع رنگ را کاهش می‌دهد.",
    "Blind Profile": "پروفایل نابینایان",
    "Activates the screen reader for auditory navigation.": "صفحه‌خوان را برای ناوبری شنیداری فعال می‌کند.",
    "Visually Impaired Profile": "پروفایل کم‌بینایان",
    "Enhances contrast and readability for low vision.": "کنتراست و خوانایی را برای کم‌بینایان بهبود می‌دهد.",
    "ADHD Friendly Profile": "پروفایل مناسب برای ADHD",
    "Reduces distractions for better focus.": "حواس‌پرتی را برای تمرکز بهتر کاهش می‌دهد.",
    "Cognitive & Learning Profile": "پروفایل شناختی و یادگیری",
    "Helpful tools for reading and comprehension.": "ابزارهای مفید برای خواندن و درک مطلب.",
    "Motor Impaired Profile": "پروفایل معلولیت حرکتی",
    "Optimizes the site for keyboard-only navigation.": "سایت را برای ناوبری فقط با کیبورد بهینه می‌کند.",
    "Headings": "عناوین",
    "Landmarks": "نشانه‌ها",
    "Links": "لینک‌ها",
    "Focus element": "تمرکز روی عنصر",
    "Visit link": "بازدید از لینک"
}